import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getRecent } from "@/lib/recentlyViewed";
import { displayTitle } from "@/lib/title";

const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

// Privacy-conscious "Recently viewed" rail — reads only this browser's
// localStorage (see lib/recentlyViewed.js); nothing is sent anywhere.
export const RecentlyViewed = ({ excludeSku = null }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getRecent(excludeSku).slice(0, 8));
  }, [excludeSku]);

  if (items.length === 0) return null;

  return (
    <section className="mt-20" data-testid="recently-viewed">
      <h2 className="text-xs uppercase tracking-[0.2em] text-[#C9A227] font-semibold">Recently viewed</h2>
      <div className="mt-6 flex gap-5 overflow-x-auto pb-4 -mx-6 px-6 sm:mx-0 sm:px-0">
        {items.map((p) => (
          <Link
            key={p.sku}
            to={p.path}
            data-testid={`recent-card-${p.sku}`}
            className="group w-[150px] sm:w-[170px] shrink-0 bg-white border border-[#E8DCC4] rounded-sm overflow-hidden hover:border-[#C9A227] transition-colors duration-300"
          >
            <img
              src={p.image}
              alt={displayTitle({ seo_title: p.title })}
              loading="lazy"
              className="w-full h-[120px] object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
            />
            <div className="p-3">
              <p className="text-xs font-semibold text-neutral-900 leading-snug line-clamp-2">{displayTitle({ seo_title: p.title })}</p>
              <p className="text-sm font-bold text-[#C9A227] mt-1">{money(p.price)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
